import * as MicrosoftSDK from "microsoft-cognitiveservices-speech-sdk";
import { SUBSCRIPTION_KEY, SERVICE_REGION } from "@joyz/app-core/constants/microphone/keys";

const endpoint =
  "wss://" +
  SERVICE_REGION +
  ".stt.speech.microsoft.com/speech/recognition/conversation/cognitiveservices/v1";

export const speechConfig: MicrosoftSDK.SpeechConfig = MicrosoftSDK.SpeechConfig.fromEndpoint(
  new URL(endpoint),
  SUBSCRIPTION_KEY
);

const language = speechConfig.getProperty("SpeechServiceConnection_RecoLanguage");
const format = speechConfig.getProperty("OutputFormat");

export const azureWebSocketURL = `${endpoint}?language=${language}&format=${format}&Ocp-Apim-Subscription-Key=${SUBSCRIPTION_KEY}`;
